import angular from 'angular';
import dompurify from 'dompurify';
const sanitizer = dompurify.sanitize;
angular.module('commonServices').filter('domPurify', [
  function() {
    return function(text) {
      if (!text) return text;
      return sanitizer(text);
    };
  },
]);
